import { label } from "aws-amplify";
import {
  InvoiceStatusDataType,
  RecallInvoiceDetailsType,
} from "../../../../Types/invoiceManagementTypes";
import styles from "./RecallConfirmationModal.module.scss";
import {
  InvoiceStatus,
  QuickbookStatus,
} from "../../../../enums/InvoiceManagementEnums";
import clsx from "clsx";

export const RecallConfirmationModalConsts = {
  MODAL_TITLE: "Confirm Recall",
  MODAL_WIDTH: "50rem",
  TABLE_SIZE: "small",
  SCROLL_BEHAVIOUR: { y: "23.5rem", x: "max-content" },
  RECALL_DETAILS_HEADER: "To be recalled for:",
  MAIN_MESSAGE:
    "Are you sure you would like to recall all tickets associated with this invoice?",
  NOTE_HEADER: "Note:",
  NOTE_MESSAGE:
    "Download for the original file will be triggered on completion. Please accept it.",
};

export const getInvoiceIdText = (invoiceList: InvoiceStatusDataType[]) => (
  <>
    {"Invoice(s) "}
    {invoiceList} will be deleted from the system
  </>
);

export const getFormattedInvoiceList = (arr: InvoiceStatusDataType[]) => {
  const formattedList = arr?.map((item) => (
    <span className={styles.boldHighlight}>{item?.invoiceId}</span>
  ));
  if (arr?.length === 1) {
    return formattedList[0];
  } else if (arr?.length === 2) {
    return [formattedList[0], " and ", formattedList[1]];
  } else if (arr?.length > 2) {
    return [
      ...formattedList.slice(0, -1).flatMap((el) => [el, ", "]),
      "and ",
      formattedList.at(-1),
    ];
  } else {
    return [];
  }
};

export const getBatchDetails = (invoiceDetails: RecallInvoiceDetailsType) => {
  return [
    {
      span: 9,
      value: invoiceDetails?.customerName ?? "-",
      label: "Customer Name",
    },
    {
      span: 7,
      value: invoiceDetails?.truckNumber ?? "-",
      label: "Truck No",
    },
    {
      span: 7,
      value: invoiceDetails?.jobNumber ?? "-",
      label: "Job No",
    },
    {
      span: 9,
      value: invoiceDetails?.jobName ?? "-",
      label: "Job Name",
    },
    {
      span: 15,
      value: invoiceDetails?.order ?? "-",
      label: "Order",
    },
  ];
};

export const invoiceStatusColumns = [
  {
    title: "Invoice Id",
    dataIndex: "invoiceId",
    key: "invoiceId",
    width: "60px",
    align: "center",
  },
  {
    title: "Status",
    dataIndex: "invoiceStatus",
    key: "invoiceStatus",
    width: "60px",
    align: "center",
    render: (val, record) => {
      return (
        <div
          className={clsx(styles.StatusPill, {
            [styles.StatusPillSent]: val === InvoiceStatus.SENT,
            [styles.StatusPillReviewed]: val === InvoiceStatus.REVIEWED,
            [styles.StatusPillNotReviewed]: val === InvoiceStatus.NOT_REVIEWED,
          })}
        >
          {val}
        </div>
      );
    },
  },
  {
    title: "Quickbooks Status",
    dataIndex: "syncStatus",
    key: "syncStatus",
    width: "60px",
    align: "center",
    render: (val, record) => {
      return (
        <div
          className={clsx(styles.StatusPill, {
            [styles.StatusPillSynced]: val === QuickbookStatus.SYNCED,
            [styles.StatusPillNotSynced]: val === QuickbookStatus.NOT_SYNCED,
          })}
        >
          {val}
        </div>
      );
    },
  },
];
